import { render } from "./ChatForm.vue?vue&type=template&id=286c3032&scoped=true"
import script from "./ChatForm.vue?vue&type=script&lang=js"
export * from "./ChatForm.vue?vue&type=script&lang=js"

import "./ChatForm.vue?vue&type=style&index=0&id=286c3032&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286c3032"]])

export default __exports__